// POM-5299 — shared rule for restricting "void shipment" once the carrier has the package.
//
// We deliberately treat ANY of the three carrier tracking events (picked up, out for
// delivery, delivered) as "picked up": the FedEx picked-up webhook can be missed, and
// out-for-delivery / delivered both imply the package was already collected. The backend
// (prx-shipment-service) enforces the same rule — this helper drives the UI guard so the
// action can be disabled with an explanatory tooltip before the user attempts it.

export const PICKED_UP_VOID_TOOLTIP_PREFIX = 'Cannot void — shipment has already been';

/**
 * @param {object|object[]} items A shipment-like object, or an array of them (e.g. line
 *   items), each optionally carrying pickedUpTimestamp / outForDeliveryTimestamp /
 *   deliveredTimestamp.
 * @returns {{ isPickedUp: boolean, statusLabel: string, tooltip: string }}
 */
export const getPickupVoidRestriction = (items = []) => {
  const list = Array.isArray(items) ? items : [items];
  const has = (key) => list.some((item) => item && item[key]);

  const delivered = has('deliveredTimestamp');
  const outForDelivery = has('outForDeliveryTimestamp');
  const pickedUp = has('pickedUpTimestamp');

  const isPickedUp = delivered || outForDelivery || pickedUp;

  // Most-specific status wins for the message.
  const statusLabel =
    (delivered && 'delivered') ||
    (outForDelivery && 'out for delivery') ||
    'picked up by the carrier';

  return {
    isPickedUp,
    statusLabel,
    tooltip: isPickedUp ? `${PICKED_UP_VOID_TOOLTIP_PREFIX} ${statusLabel}.` : '',
  };
};
